import { combineReducers } from 'redux';
import AppReducer from './AppReducer';
import UserManagementReducer from './UserManagementReducer';
import SiteManagementReducer from './SiteManagementReducer';
import ClientManagementReducer from './ClientManagementReducer';
import SettingReducer from './SettingReducer';
import ManageIncidentReducer from './ManageIncidentsReducer';
import ShiftSchedulerReducer from './ShiftSchedulerReducer';
import AttendenceManagementReducer from './AttendenceManagementReducer';
import ShiftTorReducer from './ShiftTorReducer';
import CompanyOnboardingReducer from './CompanyOnboardingReducer';
import SubscriptionsReducer from './SubscriptionsReducer';
import ShiftDropOrSwapReducer from './ShiftDropOrSwapReducer';
import ReportReducer from './ReportReducer';
import AlertManagementReducer from './AlertManagementReducer';
import GeneralReducer from './GeneralReducer';

const RootReducer = combineReducers({
    AppReducer,
    UserManagementReducer,
    SiteManagementReducer,
    ClientManagementReducer,
    SettingReducer,
    ManageIncidentReducer,
    ShiftSchedulerReducer,
    AttendenceManagementReducer,
    ShiftTorReducer,
    ShiftDropOrSwapReducer,
    CompanyOnboardingReducer,
    SubscriptionsReducer,
    ReportReducer,
    AlertManagementReducer,
    GeneralReducer
});

export default RootReducer;
